Vue.component('pagination', { // get list of all data, returns list of items for current page according to number of item per page
    props: {
        data: {
            type: Array,
            default: []
        },
        itemPerPage: {
            type: Number,
            default: 25
        },
        length: {
            type: Number,
            default: 3
        },
        min: {
            type: Number,
            default: 1
        }
    },
    data: function () {
        return {
            total: 0,
            current: 1,
            fmtNext: FmtMessage.getMessage('js.pager.title.next'),
            fmtPrevious: FmtMessage.getMessage('js.pager.title.prev'),
            fmtResults: FmtMessage.getMessage("js.pager.total.results")
        }
    },
    created: function () {
        this.$emit('input', this.getPageItems(this.current));
        this.fmtNext = this.fmtNext ? this.fmtNext : 'js.pager.title.next';
        this.fmtPrevious = this.fmtPrevious ? this.fmtPrevious : 'js.pager.title.prev';
        this.fmtResults =  this.fmtResults ? this.fmtResults : 'js.pager.total.results';
    },
    methods: {
        getPageItems: function(page){
            var start = (page - 1) * this.itemPerPage;
            var end =  page * this.itemPerPage;
            return this.data.slice(start, end);
        },
        previous: function () {
            if (this.current == 1){
                return;
            }
            this.current--;
        },
        next: function () {
            if (this.current == this.total){
                return;
            }
            this.current++;
        },
        selectPage: function (page) {
            this.current = page;
        },
        getPagingRange: function(current) {
            var length = this.length;

            if (length > this.total){
                length = this.total;
            }

            var start = this.current - Math.floor(length / 2);
            start = Math.max(start, this.min);
            start = Math.min(start, this.min + this.total - length);

            return Array.from({length: length}, function (el, i) {
                return start + i;
            });
        },
    },
    computed: {
        hasData: function(){
            return this.data.length > 0;
        },
        pagingRange: function () {
            return this.getPagingRange(this.current);
        },
        hasLeftDots: function () {
            return !this.pagingRange.includes(this.min + 1) && !this.pagingRange.includes(this.min) && this.hasData;
        },
        hasRightDots: function () {
            return !this.pagingRange.includes(this.total - 1) && !this.pagingRange.includes(this.total) && this.hasData;
        },
        hasFirstPage: function () {
            return !this.pagingRange.includes(this.min);
        },
        hasLastPage: function () {
            return !this.pagingRange.includes(this.total) && this.hasData;
        }
    },
    watch: {
        data: {
            handler: function () {
                this.current = 1;
                this.total = Math.ceil(this.data.length / this.itemPerPage);
                this.$emit('input', this.getPageItems(this.min));
            },
            deep: true
        },
        current: function () {
            this.$emit('input', this.getPageItems(this.current));
        }
    },
    template: '\
    <div class="pager-list pager-footer"> \
        <a  class="pager-prevnext prev" @click="previous">&laquo; {{fmtPrevious}}</a> \
        <span class="pager-numbers" > \
            <a class="page" v-if="hasFirstPage" :class="{selected: min == current}" @click="selectPage(min)"> {{ min }}</a> \
            <span v-if="hasLeftDots">...</span> \
            <template v-for="page in pagingRange"> \
                <a :key="page" class="page" :class="{selected: page == current}" @click="selectPage(page)"> {{ page }}</a> \
            </template> \
            <span v-if="hasRightDots">...</span> \
            <a class="page" v-if="hasLastPage" :class="{selected: total == current}" @click="selectPage(total)"> {{ total }}</a> \
        </span> \
        <a  class="pager-prevnext next" @click="next">{{fmtNext}} &raquo;</a> \
        <span v-if class="pager-totalResult"><span id="pager-totalResult">{{data.length}}</span>&nbsp;{{fmtResults}}</span> \
    </div>\
    '
});
